<template>
  <div
    class="tw-px-4 tw-h-8 tw-border-b tw-border-slate-100 dark:tw-border-slate-700 tw-items-center tw-grid tw-grid-cols-6 sm:tw-grid-cols-10 tw-text-sm tw-font-medium tw-text-slate-700 dark:tw-text-slate-50"
  >
    <div class="tw-col-span-3 tw-flex tw-items-center tw-gap-1 tw-flex-nowrap">
      <img
        :src="`https://flagsapi.com/${props.data.geo.toUpperCase()}/flat/16.png`"
      />
      <div class="tw-text-nowrap tw-whitespace-nowrap">{{ country }}</div>
    </div>
    <div class="tw-hidden sm:tw-block tw-col-span-4">
      <div
        class="tw-relative tw-w-full tw-h-3 tw-rounded tw-bg-violet-50 dark:tw-bg-green-900 tw-overflow-hidden"
      >
        <div
          class="tw-absolute tw-top-0 tw-left-0 tw-h-full tw-rounded-r-sm tw-bg-violet-500 dark:tw-bg-green-400"
          :style="{ width: `${percentageShare}%` }"
        ></div>
      </div>
    </div>
    <div
      class="tw-col-span-3 tw-text-right tw-flex-nowrap tw-text-nowrap tw-whitespace-nowrap"
    >
      <span>{{ formattedCount }}</span
      >{{ " " }}
      <span class="tw-text-slate-400 dark:tw-text-slate-500"
        >({{ percentageShare }}%)</span
      >
    </div>
  </div>
</template>

<script setup>
import { byIso } from "country-code-lookup";
import { computed } from "vue";

const props = defineProps(["data", "totalCount"]);

const country = computed(() => {
  try {
    const iso = byIso(props.data.geo);
    return iso ? iso.country : `Unknown (${props.data.geo})`;
  } catch (err) {
    console.error("Error:", err, props.data.geo);
    return `Error (${props.data.geo})`;
  }
});

const formattedCount = computed(() => {
  return new Intl.NumberFormat().format(props.data.count);
});

const percentageShare = computed(() => {
  return ((props.data.count / props.totalCount) * 100).toFixed(1);
});
</script>
